import { render, staticRenderFns } from "./CanvasPreview.vue?vue&type=template&id=124b0dc6&scoped=true&"
import script from "./CanvasPreview.vue?vue&type=script&lang=js&"
export * from "./CanvasPreview.vue?vue&type=script&lang=js&"
import style0 from "./CanvasPreview.vue?vue&type=style&index=0&id=124b0dc6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "124b0dc6",
  null
  
)

export default component.exports